/* Maeve & Co — PDP enhancements: recently-viewed history */
(function(){'use strict';
  var K='maeve_recently_viewed',MAX=8,SHOW=4;
  function get(){try{return JSON.parse(localStorage.getItem(K)||'[]');}catch(e){return[];}}
  function set(a){try{localStorage.setItem(K,JSON.stringify(a));}catch(e){}}
  function currentHandle(){var p=location.pathname,s=p.split('/products/');if(s.length<2)return null;return decodeURIComponent(s[1].split('?')[0].split('#')[0].split('/')[0]);}
  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return c==='&'?'&amp;':c==='<'?'&lt;':c==='>'?'&gt;':c==='"'?'&quot;':'&#39;';});}
  function fmt(c){return '£'+(c/100).toFixed(2);}
  function track(){var h=currentHandle();if(!h)return null;var v=get().filter(function(x){return x!==h;});v.unshift(h);set(v.slice(0,MAX));return h;}
  function renderRV(){
    var c=document.querySelector('[data-maeve-rv]');if(!c)return;
    var g=c.querySelector('[data-maeve-rv-grid]');if(!g)return;
    var ch=currentHandle();
    var v=get().filter(function(x){return x!==ch;}).slice(0,SHOW);
    if(!v.length)return;
    Promise.all(v.map(function(h){return fetch('/products/'+encodeURIComponent(h)+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});})).then(function(ps){
      var ok=ps.filter(Boolean);if(!ok.length)return;
      g.innerHTML=ok.map(function(p){
        var img=p.featured_image?('<img src="'+p.featured_image+'" alt="'+esc(p.title)+'" loading="lazy">'):'';
        return '<a class="maeve-rv-card" href="'+p.url+'"><div class="maeve-rv-card__image">'+img+'</div><p class="maeve-rv-card__title">'+esc(p.title)+'</p><p class="maeve-rv-card__price">'+fmt(p.price)+'</p></a>';
      }).join('');
      c.setAttribute('data-has-items','');
    });
  }
  function init(){track();renderRV();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
